import { ReportInstance } from 'domain/entity/reportInstance';
import { Result } from 'domain/types';
import { CreateReportInstanceClient } from 'use-case/reportInstance/create/createReportInstanceClient';
import CreateReportInstanceCriteria from 'use-case/reportInstance/create/createReportInstanceCritera';

export type CreateReportInstanceResult = Result<ReportInstance>;
export type CreateReportInstance = (criteria: CreateReportInstanceCriteria) => Promise<CreateReportInstanceResult>;

export const createReportInstanceUseCase = (createReportInstanceClient: CreateReportInstanceClient): CreateReportInstance => (
    criteria: CreateReportInstanceCriteria
): Promise<CreateReportInstanceResult> => createReportInstanceClient(criteria);

export default createReportInstanceUseCase;
